export const TRUST_TRANSLATIONS = {
  "trust.title": "Mon Passeport Confiance",
  "trust.eyebrow": "DES FAITS SÉPARÉS, JAMAIS UN SCORE OPAQUE",
  "trust.subtitle": "Évalue ce qui a réellement été vérifié, interaction par interaction.",
  "trust.loading": "Chargement sécurisé du passeport…",
  "trust.offline": "Tu es hors ligne. Reconnecte-toi pour charger les données réelles.",
  "trust.error": "Le Passeport Confiance est momentanément indisponible.",
  "trust.retry": "Réessayer",
  "trust.verifications": "Mes vérifications",
  "trust.interactions": "Interactions confirmées",
  "trust.reviews": "Avis liés à une interaction confirmée",
  "trust.request": "Demander une vérification",
  "trust.email.action": "Envoyer le lien de confirmation",
  "trust.phone.unavailable": "Vérification temporairement indisponible",
  "trust.data.insufficient": "Données insuffisantes",
  "trust.premium.label": "Premium",
  "trust.verified.label": "Vérifié par Eternua",
  "trust.public.title": "Passeport Eternua Confiance",
  "trust.public.understand": "Comprendre ces informations",
  "trust.public.member_since": "Membre depuis",
  "trust.public.interactions": "interactions confirmées",
  "trust.public.reviews": "avis publiés",
  "trust.empty": "Aucune donnée confirmée à afficher pour le moment.",
};
